import type { InternalAxiosRequestConfig } from 'axios'
import { storeToRefs } from 'pinia'

export const requestAuthInterceptor = async (config: InternalAxiosRequestConfig) => {
  const auth = await import('stores/auth')
  const authStore = auth.useAuthStore()
  const { accessToken } = storeToRefs(authStore)

  if (accessToken.value) {
    config.headers['Authorization'] = `Bearer ${accessToken.value}`
  }
  return config
}
